import lifeCo from './lifeCo';
import navymutual from './navymutual';

const carrier = process.env.REACT_APP_CARRIER_ID;

const config = {
    'lc': lifeCo,
    'nm': navymutual,
}

export default config[carrier];